const messageLocationCode = Object.freeze({
  Lateral: 366,
  Inicio: 367,
  Prominente: 368,
  InicioConAcuse: 376,
});

export default messageLocationCode;
